export default "__VITE_ASSET__DBS23dE2__"